/*System Importing*/
import Vue from 'vue'
import VueRouter from 'vue-router'

/*Custom Components Importing*/
import Home from '../components/pages/Home'

// import PersonalInfo from "../components/pages/PersonalInfo";
// import PersonalInfoPreview from "../components/pages/PersonalInfoPreview";
// import PersonalSuccessMessage from "../components/pages/PersonalSuccessMessage";
// import ErrorMessage from "../components/pages/ErrorMessage";




/*Inserting VueRouter to the Vue Framework*/
Vue.use(VueRouter);


const routes = [

    {path: '/', component: Home, name: 'Home'},


];


export const router = new VueRouter({
    mode: 'history', //hides hash in url after localhost:8080
    routes: routes
});

